import { __exports as linearizeEncodings } from "./index148.js";
var hasRequiredLinearizeEncodings;
function requireLinearizeEncodings() {
  if (hasRequiredLinearizeEncodings) return linearizeEncodings;
  hasRequiredLinearizeEncodings = 1;
  Object.defineProperty(linearizeEncodings, "__esModule", {
    value: true
  });
  linearizeEncodings.default = linearizeEncodings$1;
  function linearizeEncodings$1(encodings) {
    var linearEncodings = [];
    function nextLevel(encoded) {
      if (Array.isArray(encoded)) {
        for (var i = 0; i < encoded.length; i++) {
          nextLevel(encoded[i]);
        }
      } else {
        encoded.text = encoded.text || "";
        encoded.data = encoded.data || "";
        linearEncodings.push(encoded);
      }
    }
    nextLevel(encodings);
    return linearEncodings;
  }
  return linearizeEncodings;
}
export {
  requireLinearizeEncodings as __require
};
//# sourceMappingURL=index128.js.map
